export const isProduction = () =>
  window.location.host === 'robertstoelhorst.com';
